/**
 * Welcome Email Template
 * Generates HTML email for user welcome
 */

interface WelcomeOptions {
  includeTutorial?: boolean;
  userName?: string;
}

export function generateWelcomeEmail(userName: string, options: WelcomeOptions = {}): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Welcome to SwaySuite!</title>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #4f46e5; color: white; padding: 20px; border-radius: 8px; text-align: center; }
        .content { background: #f9fafb; padding: 20px; border-radius: 8px; }
        .button { display: inline-block; background: #4f46e5; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; margin-top: 20px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Welcome to SwaySuite!</h1>
        </div>
        <div class="content">
          <p>Hi ${userName},</p>
          <p>Welcome aboard! We're thrilled to have you join SwaySuite.</p>
          <p>You now have access to powerful tools to manage your freelancing business:</p>
          <ul>
            <li>📊 Dashboard & Analytics</li>
            <li>💼 Client Management</li>
            <li>📄 Quotes & Invoices</li>
            <li>📅 Calendar & Scheduling</li>
          </ul>
          ${options.includeTutorial ? `
            <a href="${import.meta.env.VITE_CLIENT_URL || 'http://localhost:3004'}/client/dashboard" class="button">Get Started</a>
          ` : ''}
        </div>
      </div>
    </body>
    </html>
  `;
}
